import InfoOutline from "@mui/icons-material/InfoOutline";
import { Alert, Box, Button } from "@mui/material";
import { useFlag } from "../../../../server/optimizely";
import { useLexicalContext } from "../lexical-context";

import type { FC } from "react";

export const SmsNonGsmBanner: FC = () => {
  const [highlightNonGsm] = useFlag("cha_4513_highlight_non_gsm_characters");
  const {
    text: { nonGSMCharacters, nonGsmHighlightVisible, setNonGsmHighlightVisible },
  } = useLexicalContext();

  if (!highlightNonGsm || nonGSMCharacters.length === 0) return null;

  const uniqueChars = [...new Set(nonGSMCharacters)];
  const displayChars = uniqueChars.map((c) => `"${c}"`).join(" ");

  return (
    <Box sx={{ mb: 1 }}>
      <Alert
        icon={<InfoOutline />}
        severity="info"
        sx={{ alignItems: "center", "& .MuiAlert-action": { pt: 0 } }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => setNonGsmHighlightVisible(!nonGsmHighlightVisible)}
            data-analytics-id="sms-non-gsm-banner-toggle"
          >
            {nonGsmHighlightVisible ? "Hide" : "Show"}
          </Button>
        }
      >
        Your message contains special characters ({displayChars}), which use more of your character
        count than usual.
      </Alert>
    </Box>
  );
};
